<ngx-loading-bar [includeSpinner]="false" height="4px" color="#FF0000"></ngx-loading-bar>
<div class="pages">
    <div data-page="blog" class="page no-toolbar no-navbar">
        <div class="page-content">
            <div class="navbarpages"
                 [ngStyle]="{'min-height': debug ? '500px' : '0px', 'z-index': debug ? '99' : '10', 'overflow-y': debug ? 'scroll': 'hidden'}">
                <div class="navbar_left">
                    <a [routerLink]="['/menu']"><img src="./assets/images/icons/blue/menu.png"/></a>
                </div>
                <div class="navbar_center">
                    <h2>Neuerungen</h2>
                </div>
            </div>

            <div id="pages_maincontent">
                <div class="page_content">
                    <h4><b><u>V4.0.75 - 14.12.2025</u></b></h4>
                    <ul class="list-group">
                        <li class="list-group-item">Update von Softwarekomponenten</li>
                    </ul>
                </div><br>
                <div class="page_content">
                    <h4><b><u>V4.0.72 - 30.03.2024</u></b></h4>
                    <ul class="list-group">
                        <li class="list-group-item">Seite mit den App Neuerungen (diese hier)</li>
                        <li class="list-group-item">Pocsag: Wenn ein Filter akitv ist und eine neue Meldung kommt, so wird der Filter nicht mehr deaktiviert</li>
                        <li class="list-group-item"><img src="/assets/images/info.png" width="75px"> Wird nun angezigt, wenn zu einem Einsatz Daten von der Leistelle vorhanden sind. aktuell nur Amt Trave Land. Details dann wenn man auf den Einsatz klickt</li>
                        <li class="list-group-item">Schon länger vorhanden: Auf einen Einsatz klicken, werden Daten aus der Historie zu diesem Alarmort angezeigt</li>

                    </ul>
                </div>
                <br>

            </div>
        </div>
    </div>
</div>
